require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./deschutes-county-cit.json") })
        }
      }, "path---deschutes-county-cit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---deschutes-county-cit!./.cache/json/deschutes-county-cit.json
// module id = 873
// module chunks = 231608221292675